﻿$.fn.dxCtrlContentEnvoiMailingPrevi = function custom_dxCtrlContentEnvoiMailingPrevi(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentenvoimailingprevi dx-ctrl");
        this.createInstance(new cdxCtrlContentEnvoiMailingPrevi(this, option));
    }
    return this;
}

window.cdxCtrlContentEnvoiMailingPrevi = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dxVisu = null
    var jauge = null
    var dataHtml = null;
    function mConstruit() {
        dataHtml = null
        if (dxVisu != null) dxVisu.destroy()
        container.empty()
        container.css("height", "100%")
        container.css("position", "relative")
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        jauge.mShow()
        switch (option.type) {
            case "sms":
                dxVisu = $("<div style='height:100%'/>").appendTo(container).dxCtrlContentSmsMobile({
                    bddCtrl: option.bddCtrl,
                    data: option.data,
                    onValueChanged: option.onValueChanged
                }).dxCtrlContentSmsMobile("instance")
                jauge.mHide()
                break;
            case "email":
                container.css("padding", "0 0 0 20px")
                var $DivBt = $("<div/>").appendTo(container)
                if (!(option.data.tracking == "1" &&
                    option.data.id_type_classement >= 8 &&
                    option.data.id_type_classement <= 13)) {
                    //modifier
                    dxBtModif = $("<div style='margin-bottom:5px;'/>").appendTo($DivBt).dxCtrlButton({
                        text: "Modifier",
                        onClick: function (e) {
                            //mModifier()
                            option.onDisplayModif()
                        }
                    }).dxCtrlButton("instance")
                } else {
                    var $Table = $("<table/>").appendTo($DivBt)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%'/>").appendTo($Tr)
                    if (option.bddCtrl.baseAppli.para.bdd.utilise_classeur) {
                        var obj = option.bddCtrl.getObjet(option.data)
                        $("<div/>").appendTo($Td).dxCtrlSelectClasseur({
                            bddCtrl: option.bddCtrl,
                            idTable: obj.mGetTable().id_table,
                            id: obj.cle(),
                            onDemandeSave: function (funcSaved) {
                                var obj = option.bddCtrl.getObjet(option.data)
                                if (obj.cle() == null) {
                                    obj.mSave(function () { if (typeof funcSaved != 'undefined') funcSaved(obj.cle()) })
                                } else {
                                    if (typeof funcSaved != 'undefined') funcSaved(obj.cle())
                                }
                            }
                        })
                    }
                    var $Td = $("<td style='width:1%'/>").appendTo($Tr)
                    $("<div style='margin-bottom:5px;'/>").appendTo($Td).dxCtrlButton({
                        text: "Sauvegarder dans la box",
                        onClick: function (e) {
                            var dxContentEmailBase = $("<div style='height:100%;display:none;'/>").appendTo($Td).dxCtrlContentEmailBase({
                                bddCtrl: option.bddCtrl,
                                readOnly: true,
                                data: option.data,
                                showObjet: true,
                                saveAuto: false
                            }).dxCtrlContentEmailBase("instance")
                            var objet = option.data.objet
                            if (typeof objet == "undefined" || objet == null || objet.length == 0) objet = "Nouveau document email"
                            carInterditFichier.forEach(function (car) { objet = objet.remplacerTout(car, "_") })
                            var pathNomFichier = option.bddCtrl.repertoireBrouillon + "/" + objet + ".emlz"
                            window.setTimeout(function () { dxContentEmailBase.mDemandeExport(objet, pathNomFichier) }, 100)
                        }
                    }).dxCtrlButton("instance")
                    $DivBt.css("margin-bottom", "5px")
                    $("<div/>").appendTo($DivBt).dxCtrlTextBox({
                        labelMode: 'floating',
                        label: ((typeof option.labelObjet != 'undefined') ? option.labelObjet : "Objet"),
                        readOnly: true,
                        value: option.data.objet
                    }).dxCtrlTextBox("instance")


                }

                var $DivFileJoin = $("<div/>").appendTo(container)
                option.bddCtrl.mAjaxCall({
                    command: "getdataemailbdd",
                    nom_table: option.bddCtrl.getObjet(option.data).mGetTable().nom,
                    id: option.bddCtrl.getObjet(option.data).cle()
                }, function (data) {
                    if (data.lstfile && data.lstfile.length > 0) {
                        $("<div/>").appendTo($DivFileJoin).dxCtrlFichier2Document({
                            bddCtrl: option.bddCtrl,
                            dataSource: data.lstfile,
                            readOnly: true,
                            imgInternet: ((option.showOnlyUploadMachine) ? false : !parametre.isMobile),
                            box: ((option.showOnlyUploadMachine) ? false : true),
                            icone: false,
                            docCpt: ((option.showOnlyUploadMachine) ? false : !parametre.isMobile),
                            courrier: ((option.showOnlyUploadMachine) ? false : !parametre.isMobile)
                        }).dxCtrlFichier2Document("instance")
                    }
                })

                option.bddCtrl.mAjaxCall({
                    command: "gethtmlurldataemailbdd",
                    nom_table: option.bddCtrl.getObjet(option.data).mGetTable().nom,
                    id: option.bddCtrl.getObjet(option.data).cle()
                }, function (data) {
                    var dxScroll = $("<div style='border:" + theme.border + ";height:calc(100% - " + ($DivBt.innerHeight() + $DivFileJoin.innerHeight() + 8) + "px);background-color:white;'/>").appendTo(container).dxScrollView({}).dxScrollView("instance")
                    dxVisu = $("<div style='width:100%;'/>").appendTo(dxScroll.content()).dxCtrlIframeResize({
                        disabled: true,
                        src: data.urlhtml,
                        deltaX: 0,
                        onContentReady: function (component) {
                            component.element().find("iframe").css("min-height", "100%")
                            jauge.mHide()
                        }
                    }).dxCtrlIframeResize("instance")
                })
                break;
        }
    }

    this.mUpdate = function () {
        dxVisu.mUpdate()
    }

    this.mGetDataHtml = function () { return dataHtml }

    function mModifier(pathName, dataGrid, html) {
        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
            fullScreen: true,
            showTitle: false,
            contentTemplate: function (contentElement) {
                contentElement.css("position", "relative")
                dxContentEmailBase = $("<div style='height:100%'/>").appendTo(contentElement).dxCtrlContentEmailBase({
                    bddCtrl: option.bddCtrl,
                    readOnly: false,
                    data: option.data,
                    showObjet: false,
                    saveAuto: true,
                    onDemandeUrl: function (funcFin) {
                        dxContentEmailBase.mSaveAuto(function () {
                            option.bddCtrl.mAjaxCall({ command: "getemailurl", id_com_email_envoi: option.data.id_com_email_envoi }, function (data) {
                                funcFin(data.url)
                            })
                        })
                    },
                    onSave: function () {
                        //mRempliTaille()
                    },
                    onContentReady: function () {
                        dxContentEmailBase.option("onContentReady", null)
                        if (pathName != null) {
                            window.setTimeout(function () {
                                option.data.is_empty_on_init = "0"
                                option.bddCtrl.getObjet(option.data).mSaveChamp("is_empty_on_init")
                                if (pathName != null) {
                                    option.bddCtrl.mAjaxCall({ command: "getdatafichieremlz", id_fichier: pathName }, function (data) {
                                        dxContentEmailBase.mChangeObjet(data.objet)
                                        option.data.objet = data.objet
                                        dxContentEmailBase.mClearFiles()
                                        if (typeof data.lstfile != 'undefined') dxContentEmailBase.mAddFiles(data.lstfile)
                                        dxContentEmailBase.mClearFilesHeberge()
                                        if (typeof data.lstfileheberge != 'undefined') dxContentEmailBase.mAddFilesHeberge(data.lstfileheberge)
                                        dxContentEmailBase.mChangeLstChampsSaisie(JSON.parse(data.lstChampSaisie))
                                        dxContentEmailBase.mChangeHtml(data.html, data.htmlSansBody, function () {
                                            window.setTimeout(function () {
                                                dxContentEmailBase.mStopSaveAuto(function () {
                                                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                                                    mConstruit()
                                                    mModifier()
                                                    jauge.mHide()
                                                })
                                            }, 1000)
                                        })
                                    })
                                } else if (dataGrid != null) {
                                    option.bddCtrl.mAjaxCall({ command: "getdataemailbdd", nom_table: "com_email_envoi", id: dataGrid.id }, function (data) {
                                        dxContentEmailBase.mChangeObjet(data.objet)
                                        option.data.objet = data.objet
                                        dxContentEmailBase.mClearFiles()
                                        if (typeof data.lstfile != 'undefined') dxContentEmailBase.mAddFiles(data.lstfile)
                                        dxContentEmailBase.mClearFilesHeberge()
                                        if (typeof data.lstfileheberge != 'undefined') dxContentEmailBase.mAddFilesHeberge(data.lstfileheberge)
                                        dxContentEmailBase.mChangeLstChampsSaisie(JSON.parse(data.lstChampSaisie))
                                        dxContentEmailBase.mChangeHtml(data.html, data.htmlSansBody, function () {
                                            window.setTimeout(function () {
                                                dxContentEmailBase.mStopSaveAuto(function () {
                                                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                                                    mConstruit()
                                                    mModifier()
                                                    jauge.mHide()
                                                })
                                            }, 1000)
                                        })
                                    })
                                } else if (html != null) {
                                    dxContentEmailBase.mChangeObjet("")
                                    option.data.objet = ""
                                    dxContentEmailBase.mClearFiles()
                                    dxContentEmailBase.mClearFilesHeberge()
                                    dxContentEmailBase.mChangeLstChampsSaisie([])
                                    dxContentEmailBase.mChangeHtml(html, "", function () {
                                        window.setTimeout(function () {
                                            dxContentEmailBase.mStopSaveAuto(function () {
                                                if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                                                mConstruit()
                                                mModifier()
                                                jauge.mHide()
                                            })
                                        }, 1000)
                                    })
                                }

                            }, 500)
                        }
                    }
                }).dxCtrlContentEmailBase("instance")
            },
            onShown: function (e) {
                jaugeDemarrage.mHide()
            },
            onHiding: function (e) {
                jauge.mShow()
                dxContentEmailBase.mStopSaveAuto(function () {
                    option.bddCtrl.mAjaxCall({
                        command: "gethtmlurldataemailbdd",
                        nom_table: option.bddCtrl.getObjet(option.data).mGetTable().nom,
                        id: option.bddCtrl.getObjet(option.data).cle()
                    }, function (data) {
                        dxVisu.mUpdate(data.urlhtml)
                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                        jauge.mHide()
                    })
                })
            }
        }).dxCtrlPopupBase("instance")
        popup.show()
    }

    this.element = function () { return container }

    mConstruit();
}